import { useAppSelector } from '@core/js/store/hooks';
import { useImageFallback } from '../useImageFallback';
import { pick } from 'ramda';

type UseGameImageFallback = {
    image?: string;
    longImg?: string;
    gameCode?: string;
}

export const useGameImageFallback = ({
    image = '',
    longImg = '',
    gameCode = ''
}: UseGameImageFallback) => {
    const { themeName } = useAppSelector(pick(['themeName']));
    const { src: portraitImageSrc, handleError: portraitImageHandleError, handleSetImage: handleSetPortraitImage } = useImageFallback({ initialSrc: longImg, fallbackSrc: `/${themeName}/images/PortraitPlaceholder.png`, gameCode });
    const { src: landscapeImageSrc, handleError: landscapeImageHandleError, handleSetImage: handleSetLandscapeImage } = useImageFallback({ initialSrc: image, fallbackSrc: `/${themeName}/images/LandscapePlaceholder.png`, gameCode });

    return {
        portraitImageSrc,
        landscapeImageSrc,
        portraitImageHandleError,
        landscapeImageHandleError,
        handleSetPortraitImage,
        handleSetLandscapeImage
    };
};
